export const enum CognitoUserGroups {
  USER = 'users',
  ADMIN = 'admin',
}
